<div class="face-detection-container">
  <div #container class="camera-container"></div>
  <canvas #overlay class="overlay-canvas"></canvas>
</div>
